module.exports = __webpack_public_path__ + "img/technology.5c60e5d6.png";